import _ from 'lodash'
import { Switch as cSwitch } from '@coreui/vue'

// path, paramater 만 지원
export default {
  name: 'RuleMethod',
  props: ['origin', 'name', 'is_setup', 'example', 'origin_use_method', '_show_block_only'],
  components : { cSwitch },
  computed: {},
  watch: {
    origin() {
      // 기존 값이 변경시 해당 데이터 업데이트, 컴포넌트로 사용시 필요
      // this.load() // 뷰 순환 참조로 사용하지 못함
      console.log('RuleMethod.vue', 'changed');
      this.method_list = this.origin && this.origin.length ?  this.origin : this.method_list
      this.use_method = this.origin_use_method
    }
  },
  data: () => {
    return {
      method_list : [
        { method : 'GET',  ip_list : "", is_block : false, is_mode : true, },
        { method : 'POST',  ip_list : "", is_block : false, is_mode : true, },
        { method : 'DELETE',  ip_list : "", is_block : false, is_mode : true, },
        { method : 'PATCH',  ip_list : "", is_block : false, is_mode : true, },
        { method : 'PUT',  ip_list : "", is_block : false, is_mode : true, },
        { method : 'OPTIONS',  ip_list : "", is_block : false, is_mode : true, },
      ],
      select_all : false,
      country : '',
      explain_modal :false,
      model : [],
      ex : '',
      use_method : false,
      loading : false
    }
  },
  methods: {
    change_use_method(val) {
      // console.log('toggle', val, this.use_method)
      this.$parent.$emit('use_method', val) // 변경될 때마다 업데이트
    },
    refresh() {
      // some action here
      this.$parent.$emit("refresh")
    },
    load() {
      console.log('RuleMethod.vue', 'mounted', this.origin.length);
      this.method_list = this.origin && this.origin.length ?  this.origin : this.method_list
      this.use_method = this.origin_use_method
      this.loading = false;
    },
    update($value, key, type) {
      if(this.loading) {
        return console.log('loading is no updated', key, type)
      }
      this.method_list[_.findIndex(this.method_list, x => x.method == key)][type] = $value
      this.$parent.$emit('update', this.method_list)
      location.hostname == 'localhost' ? console.info('update RuleCustom => parent', $value, key) : ''
    },
  },
  created: function() { console.log('RuleMethod.vue', 'created'); this.loading = true; },
  destroyed: function() { console.log('RuleMethod.vue', 'destroyed'); },
  mounted: function() { this.load() }
}
